/** @jsx jsx */
import { jsx } from "theme-ui";
import { Link } from "gatsby";
import Layout from "./layout";
import Hero from "../texts/hero";
import RecentWork from "../texts/recent";
import Bottom from "../texts/bottom";
import Title from "./title";
import Listing from "./listing";
import List from "./list";
import useSiteMetadata from "../hooks/use-site-metadata";
import replaceSlashes from "../utils/replaceSlashes";

type PostsProps = {
  posts: {
    slug: string;
    title: string;
    date: string;
    draft: boolean;
    tags?: {
      name: string;
      slug: string;
    }[];
  }[];
};

const Homepage = ({ posts }: PostsProps) => {
  const { basePath, blogPath } = useSiteMetadata();

  return (
    <Layout>
      <section sx={{ mb: [5, 6, 7], p: { fontSize: [1, 2, 3], mt: 2 } }}>
        <Hero />
      </section>

      {/* Recent Work */}
      <section sx={{ mb: [5, 6], p: { fontSize: [1, 2, 3], mt: 2 } }}>
        <Title text="Recent Projects" />
        <RecentWork />
      </section>

      {/* Latest Posts */}
      {/* <Title text="Latest Posts">
        <Link to={replaceSlashes(`/${basePath}/${blogPath}`)}>
          Read all posts
        </Link>
      </Title> */}
      {/* <Listing posts={posts} showTags={false} /> */}
      <List>
        <Bottom />
      </List>
    </Layout>
  );
};

export default Homepage;
